import { logUserEvent, logApiEvent } from '@analytics/amplifyLogging';
import { EscrowWrapper } from '@app.styled';
import { CodingConstants, UIConstants } from '@constants';
import { DataContext, WidgetsContext } from '@context';
import { auth, config } from '../config';
import React, { useContext, useEffect } from 'react';
import { EscrowAnalysisProps, EventType, EscrowAnalysisSummary } from 'shared-ui-components';

export const EscrowContainer: React.FC<any> = props => {
    const authToken = auth.getOkta().getAccessToken();
    const { accountDetailSSO } = useContext(DataContext);
    const { escrowDoc } = CodingConstants;
    const { handleDocument } = useContext(WidgetsContext);
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    const escrowAnalysisInput: EscrowAnalysisProps = {
        xApiKey: `${config.env('xApiKey')}`,
        url: `${config.env('escrowUrl')}` + props.loanNumber + '/details',
        loanNumber: props.loanNumber,
        authToken: authToken,
        logApiEvent: (event: EventType) => {
            logApiEvent({
                apiName: event.apiName,
                action: event.action,
                correlationId: event.correlationId,
                timestamp: event.timestamp,
                loanNumber: event.loanNumber,
                description: event.description,
                type: 'Escrow Container'
            });
        },
        logUserEvent: (event: EventType) => {
            logUserEvent({
                action: event.action,
                type: 'Escrow Container',
                loanNumber: event.loanNumber,
                description: event.description
            });
        },
        onPayNowClick: () => accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=oneTimePayment`),
        onLearnMoreClick: () => window.open(UIConstants.escrowLearnMoreLink),
        onStatementsLinkClick: async () => handleDocument(escrowDoc, props.loanNumber),
        state: props.propertyState
    };

    return (
        <EscrowWrapper>
            <EscrowAnalysisSummary {...escrowAnalysisInput} />
        </EscrowWrapper>
    );
};
